/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r={style:{marginTop:36,fontSize:13,fontWeight:500,padding:16,borderRadius:6,maxWidth:356,minWidth:296},className:"",success:{style:{backgroundColor:"var(--success-bg)",color:"var(--success-text)",borderColor:"var(--success-border)"}},error:{style:{backgroundColor:"var(--error-bg)",color:"var(--error-text)",borderColor:"var(--error-border)"}}};export{r as toastOptions};
//# sourceMappingURL=toastOptions.js.map
